import { Col, Row } from 'antd';
import React, { useEffect, useState } from 'react';
import { useHeader } from '@app/components/header/layouts/HeaderContext';
import { BaseBreadcrumbWithRender } from '@app/components/common/BaseBreadcrumb/BaseBreadcrumb';
import FeedTable from '@app/components/apps/FeedProduction/FeedComponent';

const AddFeedProduction = () => {
  const { setBreadcrumb, clearHeaderButtons } = useHeader();
  const [currentBreadcrumName, setCurrentBreadcrumName] = useState<string>('Add Feed Production');

  const routes = [
    { path: '/feed-productions', breadcrumbName: 'Feed Production' },
    { path: '/add-feed-production', breadcrumbName: 'Add Feed Production' },
  ];

  useEffect(() => {
    setBreadcrumb(<BaseBreadcrumbWithRender routes={routes} separator=">" />);

    return () => {
      setBreadcrumb(undefined);
      clearHeaderButtons();
    };
  }, [setBreadcrumb, clearHeaderButtons]);

  return (
    <Row gutter={[16, 16]}>
      <Col span={24}>
        <FeedTable
          editable={true}
          pageTitle={'Add Feed Production'}
          type={'create'}
          setCurrentBreadcrumName={setCurrentBreadcrumName}
        />
      </Col>
    </Row>
  );
};

export default AddFeedProduction;
